import { Anexo } from './anexo.model';
import { GerenciamentoCurso } from './gerenciamento-curso.model';


export class AnexoCurso
{
    public id : number;
    public id_anexo : number;
    public id_curso : number;
    public data_exclusao: Date;

    //public anexo : Anexo[];
    public curso : GerenciamentoCurso;

}


// WEBPACK FOOTER //
// ./src/app/entity/anexo-curso.model.ts